import React from "react";
import {Modal, Popover, Radio} from "antd";
import {Config} from "../../../../controller/Global";
import {ProposalGet} from "../../../../models/crm/proposal";

const MANIFEST = Config.constant.service_type.manifest;

export class ShowProposals extends React.Component {
    state = {
        data: null
    }

    fetch = (id) => {
        ProposalGet(id)
            .then(response => {
                this.setState({data: response.data})
            });
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.data !== prevProps.data)
            this.fetch(this.props.data)
    }

    render() {
        const {data} = this.state;
        const {visible} = this.props;
        return (
            <Modal title="View Details" style={{top: 10}} visible={visible} onOk={() => this.props.setModelVisible()}
                   onCancel={() => this.props.setModelVisible()} width='85%'
                   className="view-data-modal view-proposal-mdl"
                   destroyOnClose={true}>
                {data && <div className="row single-data-row">
                    <div className="col-12 header-view-data">
                        <div className="view-data-div">
                            <span>Proposal Number</span>
                            <span>{data.id}</span>
                        </div>
                        <div className="view-data-div">
                            <span>Site</span>
                            <span>{data.site.label}</span>
                        </div>
                        <div className="view-data-div">
                            <span>Contact </span>
                            <span>{data.contact? data.contact.label: "N/A"}</span>
                        </div>
                        <div className="view-data-div">
                            <span>Cost Setting </span>
                            {data.breakdown_cost === 1 && <span>Show Breakdown of Cost</span>}
                            {data.breakdown_cost === 2 && <span>Hide Breakdown of Cost</span>}
                            {data.breakdown_cost === 3 && <span>Custom Breakdown of Cost</span>}
                            {data.breakdown_cost === 4 && <span>Custom Lump Sum (data.flat_rate)</span>}
                            {data.breakdown_cost === 5 && <span>Custom Rate by Percentage (data.flat_rate)</span>}
                        </div>
                        <div className="view-data-div">
                            <span>Created Data </span>
                            <span>{data.created}</span>
                        </div>
                        <div className="view-data-div">
                            <span>Anticipated Date </span>
                            <span>{data.anticipated_start_date}</span>
                        </div>
                        <div className="view-data-div">
                            <span>Service Type </span>
                            <span>{data.service_type.label}</span>
                        </div>
                    </div>

                    <div className="col-12 header-view-data service-view-data">
                        <h6>Service</h6>
                        <div className="view-data-div">
                            <span>Job Scope </span>
                            <span>{data.service.job_scope.label}</span>
                        </div>
                        {data.service.rental &&
                        <div className="view-data-div">
                            <span>Rental </span>
                            <span>{data.service.rental.label}</span>
                        </div>}
                        {data.service.sub_contract &&
                        <div className="view-data-div">
                            <span>Sub Contract </span>
                            <span>{data.service.sub_contract.label}</span>
                        </div>}
                        {data.service.labor.length > 0 &&
                        <div className="view-data-div propo-multiple-data">
                            <span>Labour <i className="fa fa-info-circle" aria-hidden="true"/></span>
                            <Popover overlayClassName="view-data-popover" content={
                                <div>
                                    <ul className="list-inline mb-0">
                                        {data.service.labor.map(item => <li key={item.id}>{item.label}</li>)}
                                    </ul>
                                </div>
                            } placement="topLeft" title="Labour">
                                <span>{data.service.labor[0].label}</span>
                            </Popover>
                        </div>}
                        {data.service.material.length > 0  &&
                        <div className="view-data-div propo-multiple-data">
                            <span>Material <i className="fa fa-info-circle" aria-hidden="true"/></span>
                            <Popover overlayClassName="view-data-popover" content={
                                <div>
                                    <ul className="list-inline mb-0">
                                        {data.service.material.map(item => <li key={item.id}>{item.label}</li>)}
                                    </ul>
                                </div>
                            } placement="topLeft" title="Material">
                                <span>{data.service.material[0].label}</span>
                            </Popover>
                        </div>}
                        <div className="view-data-div propo-multiple-data">
                            <span>Heavy Equipment <i className="fa fa-info-circle" aria-hidden="true"/></span>
                            <Popover overlayClassName="view-data-popover" content={
                                <div>
                                    <ul className="list-inline mb-0">
                                        {data.service.heavy_equipment.map(item => <li key={item.id}>{item.label}</li>)}
                                    </ul>
                                </div>
                            } placement="topLeft" title="Heavy Equipment">
                                <span>{data.service.heavy_equipment[0].label}</span>
                            </Popover>
                        </div>
                        {data.service.disposal.length > 0  &&
                        <div className="view-data-div propo-multiple-data">
                            <span>Disposal <i className="fa fa-info-circle" aria-hidden="true"/></span>
                            <Popover overlayClassName="view-data-popover" content={
                                <div>
                                    <ul className="list-inline mb-0">
                                        {data.service.disposal.map(item => <li key={item.id}>{item.label}</li>)}
                                    </ul>
                                </div>
                            } placement="topLeft" title="Disposal">
                                <span>{data.service.disposal[0].label}</span>
                            </Popover>
                        </div>}
                        {data.service.equip.length > 0  &&
                        <div className="view-data-div propo-multiple-data">
                            <span>Equip <i className="fa fa-info-circle" aria-hidden="true"/></span>
                            <Popover overlayClassName="view-data-popover" content={
                                <div>
                                    <ul className="list-inline mb-0">
                                        {data.service.equip.map(item => <li key={item.id}>{item.label}</li>)}
                                    </ul>
                                </div>
                            } placement="topLeft" title="Equip">
                                <span>{data.service.equip[0].label}</span>
                            </Popover>
                        </div>}
                    </div>
                </div>}
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/crm/proposals/popups/ShowProposals.jsx